import * as React from "react";
import {useI18N} from "../../../my-puratos/hoc/withI18N";
import {Details} from "./Details/Details";
import {Accordion} from "./Accordion/Accordion";

export const ProductDetails = () => {
    const translate = useI18N();

    return (
        <>
            <h2 id="product-details" className="product-details__title">{translate("Product details")}</h2>
            <Details />
            <Accordion />
        </>
    )
}
